module.exports = __webpack_public_path__ + "static/media/ContrastBadOptimized.c28b48c4.jp2";